module.exports = __webpack_public_path__ + "static/media/logo_compete2020.a67e9e22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_compete2020.svg
// module id = 322
// module chunks = 0